import ProjectList from "../components/ProjectList";

const ListProjectPage = () => {
  return (
    <ProjectList />
  );
};

export default ListProjectPage;
